module.exports = __webpack_public_path__ + "static/img/showImg01.bbbd19e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/showImg01.jpg
// module id = lDhp
// module chunks = 1